module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Light.woff2?v=6461d00c76cffcef3a4e77f07715f4f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Light.woff2
// module id = 656
// module chunks = 0